<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../../helpers/validators_files";

export default {
  components: { DatePicker },
  props: {},
  data() {
    return {
      date_wound: "",
      place_wound: "",
      dept: "",
      place_wound_in_body: "",
      disability_ratio: "",
      attachment_info: "",
    };
  },
  validations: {
    date_wound: { required },
    place_wound: { required, minLength: minLength(2), maxLength: maxLength(50) },
    dept: { required, minLength: minLength(2), maxLength: maxLength(50) },
    place_wound_in_body: { required, minLength: minLength(2), maxLength: maxLength(50) },
    disability_ratio: {
      required,
      minValue: minValue(50),
      maxValue: maxValue(100),
    },

    attachment_info: {
      // required,
      fileType: fileType("application/pdf"),
      fileSize: fileSize(1024 * 1024 * 2),
    },

    form: [
      "date_wound",
      "place_wound",
      "dept",
      "place_wound_in_body",
      "disability_ratio",
      "attachment_info",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
    chnageFile(e) {
      this[e.target.id] = e.target.files.length > 0 ? e.target.files[0] : null;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات الاصابة</h5></div>
      <b-form-group class="col-md-4 mb-3" label="تاريخ الاصابة : " label-for="date_wound">
        <date-picker
          id="date_wound"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder="اختر تاريخ الاصابة"
          v-model="date_wound"
          :class="{ 'is-invalid': $v.date_wound.$error }"
        ></date-picker>
        <div v-if="$v.date_wound.$error" class="invalid-feedback">
          <span v-if="!$v.date_wound.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" محل الحادث : " label-for="place_wound">
        <b-form-input
          id="place_wound"
          type="text"
          placeholder="ادخل محل الحادث"
          v-model="place_wound"
          :class="{ 'is-invalid': $v.place_wound.$error }"
        ></b-form-input>
        <div v-if="$v.place_wound.$error" class="invalid-feedback">
          <span v-if="!$v.place_wound.required">هذا الحقل الزامي</span>
          <span v-if="!$v.place_wound.minLength"
            >يجب أن يتكون محل الحادث من حرفين على الأقل</span
          >
          <span v-if="!$v.place_wound.maxLength"
            >يجب أن يتكون محل الحادث من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" التشكيل : " label-for="dept">
        <b-form-input
          id="dept"
          type="text"
          placeholder="ادخل التشكيل"
          v-model="dept"
          :class="{ 'is-invalid': $v.dept.$error }"
        ></b-form-input>
        <div v-if="$v.dept.$error" class="invalid-feedback">
          <span v-if="!$v.dept.required">هذا الحقل الزامي</span>
          <span v-if="!$v.dept.minLength">يجب أن يتكون التشكيل من حرفين على الأقل</span>
          <span v-if="!$v.dept.maxLength">يجب أن يتكون التشكيل من 50 حرف على الاكثر</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-6 mb-3"
        label=" مكان الاصابة بالجسم : "
        label-for="place_wound_in_body"
      >
        <b-form-input
          id="place_wound_in_body"
          type="text"
          placeholder="ادخل مكان الاصابة بالجسم "
          v-model="place_wound_in_body"
          :class="{ 'is-invalid': $v.place_wound_in_body.$error }"
        ></b-form-input>
        <div v-if="$v.place_wound_in_body.$error" class="invalid-feedback">
          <span v-if="!$v.place_wound_in_body.required">هذا الحقل الزامي</span>
          <span v-if="!$v.place_wound_in_body.minLength"
            >يجب أن يتكون مكان الاصابة بالجسم من حرفين على الأقل</span
          >
          <span v-if="!$v.place_wound_in_body.maxLength"
            >يجب أن يتكون مكان الاصابة بالجسم من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label=" نسبة العجز : "
        label-for="disability_ratio"
      >
        <b-form-input
          id="disability_ratio"
          type="number"
          placeholder="ادخل نسبة العجز"
          v-model="disability_ratio"
          :class="{ 'is-invalid': $v.disability_ratio.$error }"
        ></b-form-input>
        <div v-if="$v.disability_ratio.$error" class="invalid-feedback">
          <span v-if="!$v.disability_ratio.required">هذا الحقل الزامي</span>
          <span v-if="!$v.disability_ratio.minValue"
            >يجب أن تكون نسبة العجز 50% على الأقل</span
          >
          <span v-if="!$v.disability_ratio.maxValue"
            >يجب أن تكون نسبة العجز من 100% على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <hr class="hr-title" />
    <div class="break-title"><h5 class="mb-4">مرفقات تأييد الاصابة للجريح</h5></div>
    <ul class="li-attachments">
      <li>مرفق تأييد المجروحية وقرار نسبة العجز من الادارة المركزية حصراً .</li>
      <li>
        يجب جمع المرفقات الثبوتية للجريح اعلاه ورفعها بملف واحد بصيغة ( pdf. ) وبحجم لا
        يتجاوز ( 2mb ) .
      </li>
    </ul>
    <div class="row">
      <b-form-group
        class="col-md-12 mb-3"
        label=" مرفق تأييد الاصابة :"
        label-for="attachment_info"
      >
        <div class="custom_file">
          <b-form-file
            id="attachment_info"
            class=""
            placeholder="اختر المرفق"
            accept=".pdf"
            v-model="attachment_info"
            @change="chnageFile"
            :class="{ 'is-invalid': $v.attachment_info.$error }"
          ></b-form-file>
          <div v-if="$v.attachment_info.$error" class="invalid-feedback">
            <!-- <span v-if="!$v.attachment_info.required">هذا الحقل الزامي </span> -->
            <span v-if="!$v.attachment_info.fileSize"
              >يجب ان لا يتجاوز حجم الملف 2mb
            </span>
            <span v-if="!$v.attachment_info.fileType">يجب ان يكون نوع الملف pdf </span>
          </div>
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
